import { useEffect, useState } from "react";
import { AlertTriangle } from "lucide-react";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";

const rupiah = (n) => "Rp " + (n || 0).toLocaleString("id-ID");

export function LateSummaryCard() {
  const [month, setMonth] = useState(new Date().toISOString().slice(0, 7));
  const [data, setData] = useState(null);
  useEffect(() => {
    api.get("/attendance/late-summary", { params: { month } }).then((r) => setData(r.data)).catch(() => {});
  }, [month]);

  return (
    <Card data-testid="late-summary-card" className="rounded-2xl border-slate-200 dark:border-slate-800">
      <div className="flex flex-wrap items-center justify-between gap-3 border-b border-slate-100 px-6 py-4 dark:border-slate-800">
        <div className="flex items-center gap-2">
          <AlertTriangle className="h-4 w-4 text-rose-500" />
          <h3 className="font-heading text-lg font-semibold tracking-tight">Rekap Keterlambatan & Denda</h3>
        </div>
        <Input data-testid="late-summary-month" type="month" value={month} onChange={(e) => setMonth(e.target.value)} className="w-40" />
      </div>
      {data && (
        <p className="px-6 pt-3 text-xs text-slate-500">
          Bebas {data.policy?.free_minutes} menit/bulan · denda {rupiah(data.policy?.penalty_per_minute)}/menit setelahnya
        </p>
      )}
      <div className="overflow-x-auto p-2">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Karyawan</TableHead>
              <TableHead className="text-right">Total Telat</TableHead>
              <TableHead className="text-right">Kelebihan</TableHead>
              <TableHead className="text-right">Denda</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {(!data || data.items.length === 0) && (
              <TableRow><TableCell colSpan={4} className="py-6 text-center text-slate-400">Belum ada keterlambatan bulan ini.</TableCell></TableRow>
            )}
            {data?.items.map((it) => (
              <TableRow key={it.employee_id} data-testid="late-summary-row">
                <TableCell><p className="font-medium">{it.full_name}</p><p className="font-mono text-xs text-slate-400">{it.employee_code}</p></TableCell>
                <TableCell className="text-right font-mono">{it.total_late_minutes}m</TableCell>
                <TableCell className="text-right font-mono">{it.excess_minutes}m</TableCell>
                <TableCell className={`text-right font-mono ${it.penalty > 0 ? "font-semibold text-rose-600" : "text-slate-400"}`}>{rupiah(it.penalty)}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </Card>
  );
}
